import React, { useEffect, useState } from "react";
import { Loader } from "react-overlay-loader";
import { DatePicker, Button, Col, Row, Select, Modal } from "antd";
import Datatable from "../../component/table/dataTable";
import request from "../../lib/requester";
import moment from "moment";
import xlsx from "xlsx";

const { Option } = Select;
const { RangePicker } = DatePicker;

const TracesEmailLogBupot = () => {
  const [isLoading, setIsloading] = useState(false);
  const [data, setData] = useState([]);
  const [listPrincipal, setListPrincipal] = useState([]);

  const [principal, setPrincipal] = useState(null);
  const [uplaodDate, setUploadDate] = useState("");
  const [emailDate, setEmailDate] = useState("");

  useEffect(() => {
    getPrincipal();
  }, []);

  const search = async () => {
    // if (uplaodDate && emailDate) {
    setIsloading(true);
    let url = `/api/traces/v1/report-email?${principal ? `principal=${principal}&` : ""
      }upload_date=${uplaodDate}&email_date=${emailDate}`;
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        const maping = res.map((value) => {
          return {
            PRINCIPAL: value.org_initial,
            UPLOAD_DATE: value.upload_date_ebukpot
              ? moment(value.upload_date_ebukpot).format("DD MMMM YYYY")
              : value.upload_date_ebukpot,
            EMAIL_DATE: value.email_sent_date
              ? moment(value.email_sent_date).format("DD MMMM YYYY")
              : value.email_sent_date,
            EMAIL_SUBJECT: value.subject,
            CUSTOMER_NAME_: value.customer_name,
            EMAIL_ADRESS_PENERIMA: value.email_recipients ? value.email_recipients.replace(/"."/g, ", ") : value.email_recipients,
            EMAIL_ADRESS_GAGAL: value.failure_email_recipients ? value.failure_email_recipients.replace(/"."/g, ", ") : value.failure_email_recipients,
          };
        });
        setData(maping);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
    // } else {
    //   warning();
    // }
  };

  const getPrincipal = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/general/list-principal";
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListPrincipal(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const warning = () => {
    Modal.warning({
      title: "Failed",
      content: "Please select Date",
      onOk() {
        setData([]);
      },
    });
  };

  const downloadToXlsx = () => {
    const maping = data.map((value, index) => {
      return {
        PRINCIPAL: value.PRINCIPAL,
        UPLOAD_DATE: value.UPLOAD_DATE
          ? new Date(moment(value.UPLOAD_DATE).utc().format("DD MMM YYYY"))
          : value.UPLOAD_DATE,
        EMAIL_DATE: value.EMAIL_DATE
          ? new Date(moment(value.EMAIL_DATE).utc().format("DD MMM YYYY"))
          : value.EMAIL_DATE,
        EMAIL_SUBJECT: value.EMAIL_SUBJECT,
        CUSTOMER_NAME_: value.CUSTOMER_NAME_,
        EMAIL_ADRESS_PENERIMA: value.EMAIL_ADRESS_PENERIMA
          ? value.EMAIL_ADRESS_PENERIMA.replace(/"."/g, ", ")
          : value.EMAIL_ADRESS_PENERIMA,
        EMAIL_ADRESS_GAGAL: value.EMAIL_ADRESS_GAGAL
          ? value.EMAIL_ADRESS_GAGAL.replace(/"."/g, ", ")
          : value.EMAIL_ADRESS_GAGAL,
      };
    });

    const workBook = xlsx.utils.book_new();
    const workSheet = xlsx.utils.json_to_sheet(maping, {
      dateNF: "DD MMM YYYY",
      cellDates: true,
    });
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(
      workBook,
      `report-email-log-${moment(new Date()).format("DDMMYYYYHHmmss")}.xlsx`,
      { cellDates: true }
    );
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">Report receipt email E-Bupot</div>
                <div className="card-body">
                  <Row className="mb-3">
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Principal
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setPrincipal(e)}
                            value={principal}
                          >
                            <Option value={null}>All Principal</Option>
                            {listPrincipal.map((value, index) => {
                              return (
                                <Option key={value.org_id} value={value.org_id}>
                                  {value.org_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Upload Date
                        </label>
                        <div className="col-md-12">
                          <DatePicker
                            style={{ width: "100%" }}
                            disabledDate={false}
                            allowClear={true}
                            onChange={(value, dateStr) => {
                              setUploadDate(dateStr);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Email Date
                        </label>
                        <div className="col-md-12">
                          <DatePicker
                            style={{ width: "100%" }}
                            disabledDate={false}
                            allowClear={true}
                            onChange={(value, dateStr) => {
                              setEmailDate(dateStr);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={24} className="mb-3">
                      <Button
                        onClick={() => search()}
                        type="primary"
                        className="btn-block w-100"
                      >
                        Search
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={24}
                      style={{
                        display: `${data.length ? "flex" : "none"}`,
                        justifyContent: "end",
                        marginBottom: "-40px",
                      }}
                    >
                      <Button size="large" onClick={() => downloadToXlsx()} style={{ zIndex: 100 }}>
                        download
                      </Button>
                    </Col>
                    <Col md={24}>
                      <Datatable
                        filterButton={true}
                        data={data}
                        // download={data}
                        addTittle={"Report Email Log"}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default TracesEmailLogBupot;
